var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"ma-0 pa-0",attrs:{"items":_vm.breadCrumbList}})
}
var staticRenderFns = []

export { render, staticRenderFns }